import { TYPES } from '../constants';

const getIconType = (type) => {
  switch (type) {
    case TYPES.dark:
      return TYPES.white;
    case TYPES.error:
      return TYPES.white;
    default:
      return type;
  }
};

export default getIconType;
